import React, {Component} from 'react';
import {request} from "../../helper/APIUtils";
import Swal from "sweetalert2";
import {showAxiosError} from "../../helper/helper";
import {Alert, Button, ButtonGroup, Card, Col, ListGroup, Row, Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import CreateEndpoint from "./editdocumentations/CreateEndpoint";
import AddDocHeader from "./editdocumentations/AddDocHeader";
import UpdateDocHeader from "./editdocumentations/UpdateDocHeader";
import UpdateEndpoint from "./editdocumentations/UpdateEndpoint";
import {empty} from "ramda";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";

class DocumentationDetails extends Component {
    constructor(props) {
        super(props);
        this.deleteHeader = this.deleteHeader.bind(this);
        this.handleClickUpdateHeader = this.handleClickUpdateHeader.bind(this);
        this.handleClickCreateEndpoint = this.handleClickCreateEndpoint.bind(this);
        this.handleClickEditHeader = this.handleClickEditHeader.bind(this);
        this.getDocumentation = this.getDocumentation.bind(this);
        this.state = {
            documentation: {},
            modal: "",
            docHeaderRecordId: null,
            addHeaderTitle: "",
            headerData: null,
            selectedSection: {},
            sectionName: "",
            docName: "",
            alert: null,
            endpoints: [],
            blured: false,
            propsUpdate: false
        }
    }

    componentDidMount() {
        this.getDocumentation();
    }

    getDocumentation() {
        let self = this;
        let recordId = this.props.match.params.recordId;
        let params = {
            url: "/servicedocumentation/findDocumentationByRecordId/"+recordId,
            method: "get"
        };
        request(params)
            .then(function (response) {

                self.setState({documentation: response.data})
                if(self.state.propsUpdate){
                    let documentation = self.state.documentation;
                    let allDocumentations = self.props.getServiceDocumentation();
                    if(allDocumentations && allDocumentations.docList && allDocumentations.docList.length>0){
                        allDocumentations.docList = allDocumentations.docList.map(doc=>{
                            if(doc.recordId == documentation.recordId){
                                return documentation
                            }else{
                                return doc
                            }
                        })
                    }
                    self.setState({propsUpdate:false})
                    self.props.setServiceDocumentation(allDocumentations);
                }
            });
    }

    deleteHeader(id, data) {
        let self = this;
        let params = {
            url: "/servicedocumentation/delete" + data + "?id=" + id,
            method: "post"
        };
        request(params)
            .then(function (response) {
                if (response.data === 'Deleted') {
                    Swal("Başarılı!", "Veri başarıyla silindi !", "success");
                    self.getDocumentation();
                    self.setState({docName: "",sectionName:"",endpoints:[]})
                    self.props.getAllDocWithEndpoint();
                }
            }).catch(function (error) {
            Swal("Hata !", error, "error");
            showAxiosError(error);
        });
    }

    passiveHeader(state, recordId) {
        let self = this;
        let params = {
            url: "/servicedocumentation/passiveDocumentation/"+state+'/'+recordId,
            method: "post",
        };
        request(params)
            .then(function (response) {
                if (response.data === 'Changed') {
                    let timerInterval
                    Swal({
                        title:"Başarılı!",
                        text:"Durum başarılı bir şekilde güncellendi !",
                        timer: 1000,
                        position: 'top-left',

                        showConfirmButton: false});
                    self.getDocumentation();
                    self.props.history.push("/serviceDocumentation/add")
                }
            }).catch(function (error) {
            Swal("Hata !", error, "error");
            showAxiosError(error);
        });
    }
    passiveSection(state, record) {
        let section = {
            name: record.name,
            recordId: record.recordId,
            isActive: state
        }
        let self = this;
        let params = {
            url: "/servicedocumentation/updateSection/",
            method: "post",
            data: section
        };
        request(params)
            .then(function (response) {
                if (response.data === 'Updated') {
                    let timerInterval
                    Swal({
                        title:"Başarılı!",
                        text:"Durum başarılı bir şekilde güncellendi !",
                        timer: 1000,
                        position: 'top-left',

                        showConfirmButton: false});
                    // self.setState({propsUpdate:true});
                    self.getDocumentation();
                    self.props.getAllDocWithEndpoint();


                    // self.props.history.push("/serviceDocumentation/add")
                }
            }).catch(function (error) {
            Swal("Hata !", error, "error");
            showAxiosError(error);
        });
    }

    saveHeader(documentationId, data) {
        let url;
        let self = this;
        if (data !== null && data !== "") {
            if (documentationId != null)
                url = '/servicedocumentation/saveSection' + '?docId=' + documentationId;
            else
                url = '/servicedocumentation/saveDocumentation';
            let params = {
                url: url,
                method: 'post',
                data: {
                    name: data,
                    isActive: false
                }
            };
            request(params)
                .then(function (response) {
                    Swal("Başarılı!", "Veri başarıyla eklendi !", "success")
                    self.getDocumentation();
                }).catch(function (error) {
                Swal("Hata !", error, "error");
                showAxiosError(error);
            });
        }
    }

    updateHeader(id, url, name) {
        let self = this;
        let sendUrl = '/servicedocumentation/update' + url;
        if (name !== null && name !== "") {
            let params = {
                url: sendUrl,
                method: 'post',
                data: {
                    recordId: id,
                    name: name
                }
            };
            request(params)
                .then(function (response) {
                    Swal("Başarılı!", "Veri başarıyla güncellendi !", "success");
                    self.getDocumentation();
                }).catch(function (error) {
                Swal("Hata !", error, "error");
                showAxiosError(error);
            });
        }
    }

    handleClickUpdateEndpoint = (data, endpointRecordId) => {
        this.setState({modal: data, endpointRecordId: endpointRecordId});
    }

    handleClickCreateEndpoint(data) {
        this.setState({modal: data});
    }

    handleClickEditHeader(recordId) {
        let title;
        if (recordId !== null)
            title = this.state.documentation.name + " İçerik";
        else
            title = 'Dokümantasyon Başlığı';
        Swal({
            title: title + ' Ekle',
            input: 'text',
            showCancelButton: true,
            confirmButtonText:"Tamam",
            cancelButtonText:"İptal",
            inputValidator: (value) => {
                if (value === "")
                    return title + ' boş bırakılamaz!'
                this.saveHeader(recordId, value)
                this.props.getAllDocWithEndpoint();
            }

        });
    }



    handleClickUpdateHeader(id, url,headerData) {
        let title;
        if (url === "Documentation")
            title = "Dokümantasyon Başlığı";
        else if (url === "Section")
            title = "Dokümantasyon Bölümü";
        if (id !== null && url !== null) {
            Swal({
                title: title + " Düzenleme",
                input: 'text',
                inputValue:headerData,
                showCancelButton: true,
                confirmButtonText:"Tamam",
                cancelButtonText:"Hayır",
                inputValidator: (value) => {
                    if (value === "")
                        return title + ' boş bırakılamaz!'
                    else
                        this.updateHeader(id, url, value);
                }
            });
        }
    }

    endpointsChanger = (item) =>{
        let self = this;
        let selectedSection = {...item}
        self.setState({selectedSection:selectedSection})

        this.setState({endpoints: item.endpoint});
        this.setState({sectionName: item.name});
    }

    deleteEndpoint = (id) =>{
        let self = this;
        let params = {
            url: "/servicedocumentation/deleteEndpoint?id=" + id,
            method: "post"
        };
        request(params)
            .then(function (response) {
                if (response.data === 'Deleted') {
                    Swal("Başarılı!", "Veri başarıyla silindi !", "success");
                    self.getSection(self.state.selectedSection.recordId);
                    self.props.getAllDocWithEndpoint();
                }
            }).catch(function (error) {
            Swal("Hata !", error, "error");
            showAxiosError(error);
        });
    }
    getSection = (sectionId) => {
        let self = this;
        let params = {
            url: "/servicedocumentation/getSection?secId=" + sectionId,
            method: "get"
        };
        request(params)
            .then(function (response) {
                self.endpointsChanger(response.data);
            });
    }

    passiveEndpoint(state, endpoint) {
        let self = this;
        endpoint.isActive = state;
        if (endpoint !== null) {
            let params = {
                url: '/servicedocumentation/updateEndpoint',
                method: 'post',
                data: endpoint
            };
            request(params)
                .then(function (response) {
                    Swal("Başarılı!", "Veri başarıyla güncellendi !", "success");
                    self.getSection(self.state.selectedSection.recordId);
                    self.props.getAllDocWithEndpoint();
                }).catch(function (error) {
                Swal("Hata !", error, "error");
                showAxiosError(error);
            });
        }
    }

    onMouseOverAddSpan = (data) =>{
        if(data == "addSection"){
            const sectionAddBtn = document.getElementById("sectionAddBtn");
            sectionAddBtn.classList.add("blur")
        }
    }
    onMouseLeaveAddSpan = (data) =>{
        if(data == "addSection"){
            const sectionAddBtn = document.getElementById("sectionAddBtn");
            sectionAddBtn.classList.remove("blur")
        }
    }
    clickHandler = () =>{
        if(this.state.blured){
            const sectionAddBtn = document.getElementById("sectionAddBtn");
            sectionAddBtn.classList.remove("blur")
            this.setState({blured: false})
        }
    }
    dragHandler = (param) =>{
        const srcI = param.source.index;
        const desI = param.destination.index;
        let documentation = this.state.documentation;
        let sectionList = documentation.section;
        sectionList.splice(desI,0,sectionList.splice(srcI,1)[0]);
        sectionList.forEach((section,i)=>{
            section.sortNumber = i;
        })
        documentation.section = sectionList;
        this.updateSectionList(sectionList);
    }
    endpointsDragHandler = (param) =>{
        const srcI = param.source.index;
        const desI = param.destination.index;
        let endpointList = this.state.selectedSection.endpoint;
        endpointList.splice(desI,0,endpointList.splice(srcI,1)[0]);
        endpointList.forEach((endpoint,i)=>{
            endpoint.sortNumber = i;
        })
        this.updateEndpointList(endpointList);
    }
    updateSectionList = (sectionList) =>{
        let self = this;
        let error = null;
        if(sectionList && sectionList.length>0){
            let params = {
                url : '/servicedocumentation/updateSectionList',
                method: 'post',
                data: sectionList
            };
            request(params).
            then(function (response) {
                Swal("Başarılı!", "Liste başarılı bir şekilde güncellendi !", "success");
                self.props.getAllDocWithEndpoint();

            }).catch(function (error) {
                showAxiosError(error);
            });


            if(!error){

            }
        }


    }

    updateEndpointList = (endpointList) =>{
        let self = this;
        let error = null;
        if(endpointList && endpointList.length>0){
            let params = {
                url : '/servicedocumentation/updateEndpointList',
                method: 'post',
                data: endpointList
            };
            request(params).
            then(function (response) {
                Swal("Başarılı!", "Liste başarılı bir şekilde güncellendi !", "success");
                self.props.getAllDocWithEndpoint();

            }).catch(function (error) {
                showAxiosError(error);
            });


            if(!error){

            }
        }


    }
    render() {

        return (
                <div className="container-fluid documentation-details-container row" onClick={()=>this.clickHandler()}>
                    {this.state.alert}
                    <div className="col-sm-12 mb-2">
                        <Row>
                            <Link
                                role="button"
                                type="button"
                                className="pull-left  btnBack btn-sm"
                                title="Geri gitmek için tıklayın."
                                to="/serviceDocumentation/add">
                                <i className="fas fa-arrow-left"/>
                            </Link>
                        </Row>
                    </div>
                    <Alert key={1} variant="dark" className="documentation-details-left col-md-4">
                        <div className="documentation-details-left-title">
                            <Alert variant="secondary">
                                {this.state.documentation.name} Dokümantasyonu
                            </Alert>
                        </div>
                        <ButtonGroup style={{float: "right"}}>
                            <Button variant="success" className="sectionAddBtn"
                                    title="Dokümantasyon Başlığı oluşturmak için tıklayın."
                                    onClick={() => this.handleClickEditHeader(this.state.documentation.recordId)}
                                    id="sectionAddBtn"
                            >
                                Bölüm Ekle <i className="fas fa-plus"></i>
                            </Button>
                            <Button variant="info" className=""
                                    title="Bu Dokümantasyon başlığını düzenlemek için tıklayın."
                                    onClick={() => this.handleClickUpdateHeader(this.state.documentation.recordId, "Documentation",this.state.documentation.name)}>
                                Başlığı Düzenle <span><i className="far fa-edit"></i></span>
                            </Button>
                        </ButtonGroup>

                        {this.state.documentation.section && this.state.documentation.section.length>0 &&
                            <DragDropContext onDragEnd={(params) => this.dragHandler(params)}>
                                <Droppable droppableId="droppable-1">
                                    {(provided, snapshot) => (
                                        <ListGroup className="documentation-details-left-list" key={1} {...provided.droppableProps} ref={provided.innerRef}>
                                            {this.state.documentation.section.map((item,i) =>
                                                <Draggable key={item.name} draggableId={"draggable-"+item.name} index={i}>
                                                    {(provided) => (
                                                        <ListGroup.Item key={item.name} {...provided.draggableProps} ref={provided.innerRef}>
                                                            <div className="documentation-details-left-list-title">
                                                                <div {...provided.dragHandleProps} className="documentation-list-card-icon"><i className="fas fa-bars"></i></div>
                                                                <div onClick={() => this.endpointsChanger(item)}
                                                                     title="Bu bölümün dokümanlarını listelemek için tıklayın.">
                                                                    {item.name}
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <Button size="sm" disabled={item.isActive} variant="success"  onClick={() => this.passiveSection(true,item)}>Aktif</Button>
                                                                <Button size="sm" disabled={!item.isActive} variant="secondary" onClick={() => this.passiveSection(false,item)}>Pasif</Button>
                                                                <Button size="sm" className="left-list-btn-delete" variant="danger"
                                                                        title="Bu bölümü silmek için tıklayın.Bu işlem altındaki dokümantasyonların hepsini siler."
                                                                        onClick={() => this.setState({
                                                                            alert: (<SweetAlert
                                                                                showCancel warning
                                                                                confirmBtnText="Evet"
                                                                                cancelBtnText="Hayır"
                                                                                confirmBtnBsStyle="danger"
                                                                                cancelBtnBsStyle="default"
                                                                                title="Bu İşlemi Yapmak İstediğinize Emin Misiniz?"
                                                                                onCancel={() => this.setState({alert: null})}
                                                                                onConfirm={() => this.deleteHeader(item.recordId, "Section") & this.setState({alert: null})}>
                                                                                {item.name + " bölümü altındaki dokümantasyonların hepsini siler."}
                                                                            </SweetAlert>)
                                                                        })}><i className="fas fa-trash"></i>
                                                                </Button>
                                                            </div>
                                                        </ListGroup.Item>
                                                    )}
                                                </Draggable>
                                            )}
                                            {provided.placeholder}
                                        </ListGroup>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        }

                        { this.state.documentation.section== null || this.state.documentation.section.length == 0 &&
                            <ListGroup className="documentation-details-left-list">
                                <Alert variant="danger">
                                    Daha önce herhangi bir bölüm eklenmemiş. <span onMouseOver={()=>this.onMouseOverAddSpan("addSection")}  onMouseLeave={() => this.onMouseLeaveAddSpan("addSection")} style={{textDecoration: "underline"}}>Bölüm Ekle</span> butonundan ekleyebilirsiniz!
                                </Alert>
                            </ListGroup>
                        }
                    </Alert>
                    <Card className="documentation-details-right col-md-8">
                        <Card.Body>
                            <Card.Title className="documentation-details-right-header">
                                <div className="documentation-details-right-title">
                                    {this.state.documentation.name!="" ? this.state.documentation.name + " Dokümantasyonu ": "" }
                                    <span>{this.state.selectedSection && this.state.selectedSection.name && this.state.selectedSection.name!="" ? "( "+this.state.selectedSection.name + " )": "" }</span>
                                </div>
                                <div className="documentation-details-right-addBtn">
                                    <Button disabled={Object.keys(this.state.selectedSection)==0}
                                            onClick={() => this.handleClickCreateEndpoint('createEndpoint')}
                                            className="btn-warning"
                                            size="sm"
                                            title="Dokümantasyon Oluşturmak için tıklayın.">
                                        <i className="fas fa-plus"/> Doküman Ekle</Button>
                                </div>
                            </Card.Title>
                            <Card.Text>Sol taraftan seçili bölümü değiştirebilirsiniz</Card.Text>
                            {this.state.selectedSection && this.state.selectedSection.endpoint && this.state.selectedSection.endpoint.length>0 &&
                                <Table striped bordered hover size="sm">
                                    <thead>
                                    <tr>
                                        <th> - </th>
                                        <th>İsim</th>
                                        <th>Açıklama</th>
                                        <th>Dönüş Değeri</th>
                                        <th>İşlemler</th>
                                    </tr>
                                    </thead>
                                    <DragDropContext onDragEnd={(params) => this.endpointsDragHandler(params)}>
                                        <Droppable droppableId="droppable-1">
                                            {(provided, snapshot) => (
                                            <tbody {...provided.droppableProps} ref={provided.innerRef}>
                                                {this.state.selectedSection.endpoint.map((enpoint,i) => (
                                                    <Draggable key={enpoint.recordId} draggableId={"draggable-"+enpoint.recordId} index={i}>
                                                        {(provided) => (
                                                            <tr key={enpoint.recordId} {...provided.draggableProps} ref={provided.innerRef}>
                                                                <td><div {...provided.dragHandleProps} className="documentation-list-card-icon"><i className="fas fa-bars"></i></div></td>
                                                                <td>{enpoint.name}</td>
                                                                <td>{enpoint.explanation}</td>
                                                                <td>{enpoint.returnValue}</td>
                                                                <td>
                                                                    <ButtonGroup style={{display: "flex",justifyContent:"center"}}>
                                                                        <Button size="sm"
                                                                            className="btnUpdate"
                                                                            title="Bu dokümantasyonu düzenlemek için tıklayın."
                                                                            onClick={() => this.handleClickUpdateEndpoint("updateEndpoint", enpoint.recordId)}><i
                                                                        className="fas fa-edit"/></Button>
                                                                        <Button size="sm"
                                                                            className="btnDelete"
                                                                            title="Bu dokümantasyonu silmek için tıklayın."
                                                                            onClick={() => this.setState({
                                                                                alert: (<SweetAlert
                                                                                    showCancel warning
                                                                                    cancelBtnText="Hayır"
                                                                                    confirmBtnText="Evet"
                                                                                    confirmBtnBsStyle="danger"
                                                                                    cancelBtnBsStyle="default"
                                                                                    title="Bu İşlemi Yapmak İstediğinize Emin Misiniz?"
                                                                                    onCancel={() => this.setState({alert: null})}
                                                                                    onConfirm={() => this.deleteEndpoint(enpoint.recordId) & this.setState({alert: null})}>
                                                                                    {enpoint.name + " adlı endpointi silmek üzeresiniz."}
                                                                                </SweetAlert>)
                                                                            })}><i
                                                                        className="fas fa-minus"/></Button>
                                                                    </ButtonGroup>
                                                                    <ButtonGroup style={{marginTop:"10px"}}>
                                                                        <Button size="sm" disabled={enpoint.isActive} variant="success"  onClick={() => this.passiveEndpoint(true,enpoint)}>Aktif</Button>
                                                                        <Button size="sm" disabled={!enpoint.isActive} variant="secondary" onClick={() => this.passiveEndpoint(false,enpoint)}>Pasif</Button>
                                                                    </ButtonGroup>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </Draggable>

                                                    )
                                                )}
                                            </tbody>
                                            )}
                                        </Droppable>
                                    </DragDropContext>

                                </Table>

                            }
                            {this.state.documentation && this.state.documentation.section && Object.keys(this.state.documentation.section).length ==0 &&
                                <Alert variant="warning">
                                    Dokümantasyonları ekleyip görüntülüyebilmeniz için sol taraftan Bölüm oluşturunuz.
                                </Alert>
                            }
                            {this.state.documentation && this.state.documentation.section && this.state.documentation.section.length >0 && Object.keys(this.state.selectedSection).length ==0 &&
                                <Alert variant="warning">
                                    Sol taraftan bölüm seçiniz lütfen.
                                </Alert>
                            }

                            {this.state.documentation && this.state.documentation.section && this.state.documentation.section.length >0 && this.state.selectedSection && this.state.selectedSection.endpoint && this.state.selectedSection.endpoint.length==0 &&
                                <Alert variant="warning">
                                    Seçili bölüme dokümantasyon eklenmemiş!
                                </Alert>
                            }
                        </Card.Body>

                    </Card>
                    {this.state.modal === "createEndpoint" &&
                        <CreateEndpoint onOpen={this.handleClickCreateEndpoint}
                                        sectionRecordId={this.state.selectedSection.recordId}
                                        secName={this.state.selectedSection.name}
                                        docName={this.state.documentation.name}
                                        refresh={this.getSection}/>}

                    {this.state.modal === "updateEndpoint" &&
                        <UpdateEndpoint onOpen={this.handleClickUpdateEndpoint}
                                        endpointRecordId={this.state.endpointRecordId}
                                        sectionRecordId={this.state.selectedSection.recordId}
                                        docName={this.state.documentation.name}
                                        sectionName={this.state.sectionName}
                                        refresh={this.getSection}> </UpdateEndpoint>
                    }
                </div>
        )

    }
}

export default DocumentationDetails;